import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
   
    contentTitle: {
      textAlign: 'center',
      font: `700 19px/25px "Montserrat"`,
      marginBottom: 16,
      color: theme.custom.colors.primary,
    },
    subContentTitle: {
      textAlign: 'center',
      marginBottom: '50px',
      font: `400 14px/18px "Montserrat"`,
      color: theme.custom.colors.primary,
    },
    iconCloseIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '20px',
      cursor: 'pointer',
    },
    listType: {
      display: 'flex',
      width: '80%',
      justifyContent: 'center',
      margin: '0 auto',
    },
    typeTitle: {
      font: theme.custom.font.headingMontserrat3,
      marginBottom: 12,
    },
    itemType: {
      border: `1px solid ${theme.custom.colors.borderGrey}`,
      borderRadius: 10,
      width: 224,
      height: 222,
      textAlign: 'center',
      padding: '24px 9px',
      cursor: 'pointer',
      '&:focus': {
        border: `1px solid ${theme.custom.colors.purple}`,
      },
      '&:not(:last-child)': {
        marginRight: 44,
      },
      '& img': {
        marginBottom: 16,
        width: 80,
        height: 80,
      },
    },
    typeDes: {
      font: 'normal normal 400 14px/18px Montserrat',
      color: theme.custom.colors.midBlack,
      marginBottom: 13,
    },
    bodyModalList:{
      padding: '24px',
      height: '81%',
      overflowY: 'scroll'
    },
    btnAddRecipeBody: {
      '& button': {
        height: 32,
        background: theme.custom.colors.purple,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.title,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '& img': {
          marginLeft: 8,
        },
        '&:hover': {
          background: theme.custom.colors.purple,
        },
      },
    },
    footerModal: {
      height: '19%',
      padding: '24px 119px 55px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
    },
    buttonBack: {
      '& button': {
        height: 32,
        background: theme.custom.colors.borderGrey,
        fontWeight: 'bold',
        fontSize: theme.custom.fontSize.size16,
        fontFamily: 'Montserrat',
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        color: '#333333',
        marginRight: 24,
        '&:hover': {
          background: theme.custom.colors.borderGrey,
        },
      },
    },
    iconLoading: {
      marginLeft: '15px',
      '& svg': {
        color: '#fff',
      },
    },
  };
});

export default useStyles;
